import styled from 'styled-components'

const Wrapper = styled.div`

`
export default Wrapper
